export const INPUT_TYPE_KBA = 'kba';
export const INPUT_TYPE_HSN = 'hsn';
export const DE_LOCALE = 'de_DE';